import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import { MediaDto } from "../../interfaces/media";

export const olympicApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOlympics: builder.query<any, PaginateQuery>({
      query: (data) => buildPaginationQueryString(data, `/api/olympic`),
      providesTags: ["Olympic"],
    }),
    getOlympic: builder.query<any, string>({
      query: (id) => `/api/olympic/${id}`,
      providesTags: ["Olympic"],
    }),
    addUpdateOlympic: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/olympic",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Olympic"],
    }),
    deleteOlympic: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/olympic/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Olympic"],
    }),
    getOlympicParticipants: builder.query<any, PaginateQuery>({
      query: (data) =>
        buildPaginationQueryString(data, "/api/olympic/participants/results"),
      providesTags: ["Olympic"],
    }),
    getOlympicQuestion: builder.query<any, string>({
      query: (id) => `/api/olympic/question/${id}`,
      providesTags: ["Olympic"],
    }),
    getQuestionsByOlympic: builder.query<any, PaginateQuery>({
      query: (data) =>
        buildPaginationQueryString(data, `/api/olympic/question`),
      providesTags: ["Olympic"],
    }),
    addOlympicQuestion: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/olympic/question",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Olympic"],
    }),
    updateOlympicQuestion: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/olympic/question/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Olympic"],
    }),
    deleteOlympicQuestion: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/olympic/question/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Olympic"],
    }),
    uploadDisplayImage: builder.mutation<
      MediaDto,
      {
        file: File;
        questionId?: string;
        onProgress?: (progress: number) => void;
      }
    >({
      query: ({ file, questionId, onProgress }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: questionId
            ? `/api/olympic/question/upload/display-image?id=${questionId}`
            : `/api/olympic/question/upload/display-image`,
          method: "POST",
          data: formData,
          onUploadProgress: (event: any) => {
            if (event.total && onProgress) {
              onProgress(Math.round((event.loaded / event.total) * 100));
            }
          },
        };
      },
      invalidatesTags: ["Olympic"],
    }),
  }),
});

export const {
  useGetOlympicsQuery,
  useGetOlympicQuery,
  useAddUpdateOlympicMutation,
  useDeleteOlympicMutation,
  useGetOlympicParticipantsQuery,
  useGetOlympicQuestionQuery,
  useGetQuestionsByOlympicQuery,
  useAddOlympicQuestionMutation,
  useUpdateOlympicQuestionMutation,
  useDeleteOlympicQuestionMutation,
  useUploadDisplayImageMutation,
} = olympicApi;
